// extracted by mini-css-extract-plugin
export default {"legend":"chartLegend__legend___sPZVN","line":"chartLegend__line___99yYo","axisLabel":"chartLegend__axisLabel___xdqiD","additionalValue":"chartLegend__additionalValue___nQWpp"};